module.exports = __webpack_public_path__ + "img/sexta.873cb15d.jpg";